export enum DocumentSignatureType {
  MobileId = 0,
  SmartId = 1,
  Unqualified = 2,
  EParaksts = 3,
  Acknowledge = 4,
  Handwritten = 5,
  EidEasy = 6,
  Endorse = 7,
}
